import React, { useState } from "react";
import * as Icon from "react-feather";
import FsLightbox from "fslightbox-react";
import { Link } from 'react-router-dom';

function Portfolio(props) {
  const [toggler, setToggler] = useState(false);
  const {id,fileName, title, subtitle, imageUrl} = props.content;
  
  const handleToggler = (value) => {
    setToggler(value);
  }

  return (
    <div className={props.isVisible ? "mi-portfolio mi-portfolio-visible" : "mi-portfolio"}>
      <div className="mi-portfolio-image">
        <img src={imageUrl} alt={title} />
        <ul>
          <li>
              <Link to={`/projects/${id}/${fileName}`}>
                 <Icon.ExternalLink/>
              </Link>
          </li>
        </ul>
      </div>
      <h5>
        <a rel="noopener noreferrer" href={`/projects/${id}/${fileName}`}>
          {title}
        </a>
      </h5>
      {subtitle ? <h6>{subtitle}</h6> : null}
    </div>
  );
}

export default Portfolio;
